<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>统计管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/saleNumMarketing')">商品销量统计(营销)</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='商品名称'>
            <el-input
                  v-model="filters.good_name"
                  style="width:230px"
                  placeholder="请输入商品名称"
                >
                </el-input>
          </el-form-item>
          <el-form-item label='类型'>
            <el-select
              v-model="filters.type"
              clearable
            >
              <el-option label="购进销量" value="1"></el-option>
                <el-option label="红冲-抵扣" value="2"></el-option>
                <el-option label="红冲购进" value="3"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="代理类型">
              <el-select clearable v-model="filters.roleType" placeholder="请选择">
                <el-option label="无" value="-1"></el-option>
                <el-option label="康减系列vip会员" value="-0.5"></el-option>
                <el-option label="康减系列高级会员" value="-0.4"></el-option>
                <el-option label="康减系列荣誉会员" value="-0.3"></el-option>

                <el-option label="康减系列市代" value="1.1"></el-option>
                <el-option label="康减系列省代" value="2.1"></el-option>
                <el-option label="康减系列CEO" value="3.1"></el-option>

                <el-option label="VIP门店" value="0"></el-option>
                <el-option label="联盟店" value="1"></el-option>
                <el-option label="优秀联盟店" value="1.05"></el-option>
                <el-option label="市代" value="2"></el-option>
                <el-option label="省代" value="3"></el-option>
                <el-option label="CEO" value="4"></el-option>
                <el-option label="总经销商" value="5"></el-option>
                <el-option label="销售公司" value="6"></el-option>

                <el-option label="合伙人" value="2.2"></el-option>
                <el-option label="董事" value="4.2"></el-option>
              </el-select>
            </el-form-item>



          <el-form-item label="查询时间">
            <el-form-item prop="startTime">
              <el-date-picker
                type= "date"
                placeholder="选择日期"
                v-model="filters.startTime"
                :clearable = false
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
            <span style="display: inline-block;margin-right: 9px;">-</span>
            <el-form-item prop="endTime">
              <el-date-picker
                type="date"
                placeholder="选择结束日期"
                v-model="filters.endTime"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>

          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >统计</el-button>

            <el-button
              style="margin-left:10px"
              @click="goDown"
              type="danger"
              size="small"
            >到底部</el-button>

            <el-button
              style="margin-left:10px"
              @click="goTop"
              type="warn"
              size="small"
            >到顶部</el-button>

            <el-button
              style="margin-left:10px"
              @click="excelOut(1)"
              type="primary"
              size="small"
            >导出</el-button>

          </el-form-item>

        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
          请选择好条件后，点击统计
        </div>
        <el-table
          ref="dataTable"
          v-loading="listLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="good_name"
            label="商品名称"
          >
          </el-table-column>

          <el-table-column
            prop="no_vip_name"
            label="是否耗材"
          >
        </el-table-column>

          <el-table-column
            label="列表图片"
            prop="list_pic"
          >
            <template slot-scope="scope">
              <img
                :src="scope.row.list_pic"
                style="width:50px;"
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="num"
            label="销量"
          >
          </el-table-column>

          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <template>
                <el-button
                  @click="showDetailInfos(scope.row)"
                  type="text"
                  size="small"
                >查看明细</el-button>

              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-dialog
      title="明细"
      :visible.sync="subListVisible"
      width="70%"
    >
      <el-button
        type="primary"
        @click="excelOut(2)"
      >导出</el-button>
      <el-table
        v-loading="detailListLoading"
        :data="tableDetailData"
        style="width: 100%"
        max-height="500"
        :header-cell-class-name='objectSpanMethod'
      >

        <el-table-column
          prop="username"
          label="代理姓名"
        >
        </el-table-column>

        <el-table-column
          prop="role_type_name"
          label="代理级别"
        >
        </el-table-column>

        <el-table-column
          prop="telephone"
          label="代理手机号"
        >
        </el-table-column>

        <el-table-column
          prop="good_name"
          label="商品名称"
        >
        </el-table-column>

        <el-table-column
          prop="create_time_info"
          label="时间"
        >
        </el-table-column>

        <el-table-column
          prop="num"
          label="数量"
        >
        </el-table-column>

        <el-table-column
          prop="show_name"
          label="店铺名称"
        >
        </el-table-column>

        <el-table-column prop="show_name" label="店铺地址" width="200">
            <template
              slot-scope="scope"
            >{{scope.row.province}}{{scope.row.city}}{{scope.row.district}}{{scope.row.address_detail}}</template>
          </el-table-column>
      </el-table>
      <div class="pageDiv block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page_num"
          :page-count='total_page'
          :page-size="page_size"
          layout="total, prev, pager, next"
          :total="total_num"
        >
        </el-pagination>
      </div>

    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc";
var _ = require("lodash");
export default {
  name: "saleNumData",
  created() {},

  data() {
    return {
      totalMoney: 0,
      searchType:null,
      goodId:null,
      subListVisible: false,
      listLoading: false,
      noVipName: null,
      picList: [],
      filters: {
        roleType:null,
        status: null,
        startTime: new Date(new Date() - 1000 * 60 * 60 * 24 * 30),
        good_name: null,
        userId: null,
        endTime: null,
        type: null,
      },
      page_num: 1,
      keywords: "",
      pickerOptions1: 1,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      detailListLoading: false,
      tableDetailData: [],
      tableHeight:null,
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
  },
  methods: {
    goDown(){
      this.$refs.dataTable.bodyWrapper.scrollTop =this.$refs.dataTable.bodyWrapper.scrollHeight;
    },
    goTop(){
      this.$refs.dataTable.bodyWrapper.scrollTop =0;
    },
    showDetailInfos(row) {
      let that = this;
      that.subListVisible = true;
      this.page_size = 10;
      this.page_num = 1;
      this.goodId = row.id;
      this.searchDetail(this.goodId);
    },
    searchDetail(goodId) {
      let that = this;
      let para = {
        token: localStorage.getItem("api_token"),
        goodId: goodId,
        page_num: that.page_num,
        page_size: that.page_size
      };
      if (that.filters.type){
        para.type = that.filters.type
      }else{
        that.$message.error({
          showClose: true,
          message: '请选择类型',
          duration: 2000
        });
        return;
      }
      if (that.filters.startTime) {
        para.startTime = that.filters.startTime.getTime();
      }else
      {
        that.$message.error({
          showClose: true,
          message: '请选择时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        para.endTime = that.filters.endTime.getTime();
      }else
      {
        that.$message.error({
          showClose: true,
          message: '请选择时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.roleType) {
        para.roleType = that.filters.roleType;
      }
      that.detailListLoading = true;
      API.get_sale_num_list(para)
        .then(
          function(result) {
            that.detailListLoading = false;
            if (result && parseInt(result.key) === 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list != null && result.result.list.length > 0) {
                that.tableDetailData = result.result.list;
              } else {
                that.tableDetailData = [];
              }
            }
          },
          function(err) {
            that.detailListLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    excelOut(type) {
      let that = this;
      if(type == 1){
      var url =
        "/manager/user/pc/sale_good_record_count_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      if(that.filters.type){
        url = url + "&type=" + that.filters.type;
      }else{
        that.$message.error({
          showClose: true,
          message: '请选择类型',
          duration: 2000
        });
        return;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      if(that.filters.good_name){
        url = url + "&goodName=" + that.filters.good_name;
      }
      top.location.href = url;
    }else{
      var url =
        "/manager/user/pc/get_sale_num_list_excel?token=" +
        localStorage.getItem("api_token");
      if (that.filters.roleType) {
        url = url + "&roleType=" + that.filters.roleType;
      }
      if(that.filters.type){
        url = url + "&type=" + that.filters.type;
      }else{
        that.$message.error({
          showClose: true,
          message: '请选择类型',
          duration: 2000
        });
        return;
      }
      if(that.goodId){
        url = url + "&goodId=" + that.goodId
      }else{
        that.$message.error({
          showClose: true,
          message: '请选择商品',
          duration: 2000
        });
        return;
      }
      if (that.filters.startTime) {
        url = url + "&startTime=" + that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        url = url + "&endTime=" + that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      top.location.href = url;
    }
    },
    handleSearch() {
      this.search();
    },
    formatterRoleType(row, column) {
      if (row.role_type == 0) {
        return "VIP门店";
      } else if (row.role_type == -0.5) {
        return "康减系列vip会员";
      } else if (row.role_type == -0.4) {
        return "康减系列高级会员";
      } else if (row.role_type == -0.3) {
        return "康减系列荣誉会员";
      } else if (row.role_type == 1) {
        return "联盟店";
      } else if (row.role_type == 2) {
        return "市代";
      } else if (row.role_type == 3) {
        return "省代";
      } else if (row.role_type == 4) {
        return "CEO";
      } else if (row.role_type == 1.1) {
        return "康减系列市代";
      } else if (row.role_type == 2.1) {
        return "康减系列省代";
      } else if (row.role_type == 3.1) {
        return "康减系列CEO";
      } else if (row.role_type == 1.05) {
        return "优秀联盟店";
      } else if (row.role_type == 5) {
        return "总经销商";
      } else if (row.role_type == 2.2) {
        return "合伙人";
      } else if (row.role_type == 4.2) {
        return "董事";
      } else if (row.role_type == 5.1) {
        return "区域总监";
      } else if (row.role_type == 5.2) {
        return "城市加盟商";
      }  else if (row.role_type == 4.8) {
        return "经销商";
      }
    },

    search() {
      let that = this;
      let params = {
        token: localStorage.getItem("api_token")
      };
      if (that.filters.good_name) {
        params.goodName = that.filters.good_name;
      }
      if (that.filters.roleType) {
        params.roleType = that.filters.roleType;
      }
      if (that.filters.startTime) {
        params.startTime = that.filters.startTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择时间',
          duration: 2000
        });
        return;
      }
      if (that.filters.endTime) {
        params.endTime = that.filters.endTime.getTime();
      } else
      {
        that.$message.error({
          showClose: true,
          message: '请选择结束时间',
          duration: 2000
        });
        return;
      }
      if(that.filters.type){
      params.type = that.filters.type
      }else{
        that.$message.error({
          showClose: true,
          message: '请选择销量类型',
          duration: 2000
        });
        return;
      }
      API.sale_good_record_count(params)
        .then(
          function(result) {
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
                // for (var i = 0; i < result.result.list.length; i++) {
                //   if (result.result.list[i].pay_time != null) {
                //     result.result.list[i].pay_time = dateFunc.formatDate(
                //       new Date(parseInt(result.result.list[i].pay_time)),
                //       "yyyy-MM-dd hh:mm:ss"
                //     );
                //   }
                // }
              } else {
                result.result.list = [];
              }
              that.tableData = result.result.list;
            }else if(result.key == 0){
              that.tableData=[];
              that.listLoading = false;
              that.$message.error({
                showClose: true,
                message: result.message,
                duration: 2000
              });
            }
          },
          function(err) {
            that.listLoading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.listLoading = false;
          console.error(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.searchDetail(this.goodId);
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns {
  float: right;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/saleNumMarketing.vue